// Toggle Dish Online Availability
<template lang="pug">
v-btn(
  icon,
  small,
  @click.stop="submit",
  v-if="item",
  title="Online Availability",
  :loading="loading"
)
  v-icon(small, :color="color") mdi-earth
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    item: { type: Object, required: true },
  },
  data() {
    return { loading: false };
  },
  computed: {
    ...mapGetters(["biz"]),
    color() {
      if (this.item && this.item.hide) return "grey lighten-1";
      else return "success";
    },
  },
  methods: {
    async submit() {
      if (!this.biz) return;
      if (!this.item?._id) return;
      const value = !(this.item.hide == true);
      const params = {
        criteria: { _id: this.biz._id, "dishes._id": this.item._id },
        action: { $set: { "dishes.$.hide": value } },
      };
      this.loading = true;
      const data = await this.$api.biz.update(params);
      this.$store.dispatch("setBiz", data);
      this.loading = false;
    },
  },
};
</script>
